export const GRACE_PERIOD_IN_DAYS = 14;

export const ALMOST_FULL_PERCENTAGE = 95;
export const UPGRADE_PERCENTAGE = 75;
export const UPGRADE_PERCENTAGE_PRO = 90;